var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 352,
    viewBox: "0 0 350 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M167.198 87.9995C200.325 79.3309 256.453 39.7056 287.544 57.0425C318.635 74.3794 330.812 115.244 346.361 195.74C361.91 276.236 324.044 314.623 300.382 336.913C276.72 359.204 226.015 369.111 195.593 276.233C165.17 183.356 145.564 211.838 119.198 270.041C92.8317 328.245 57.6765 279.948 30.634 211.838C3.59155 143.728 -15.3382 35.9902 17.1128 8.74612C49.5637 -18.498 65.7892 23.6066 89.4514 57.0425C113.114 90.4785 134.071 96.6681 167.198 87.9995Z",
    fill: "#E47860",
    style: {
      mixBlendMode: "lighten"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob10);
export default __webpack_public_path__ + "static/media/blob10.38540dca7b0d901e3acf1d9a2e3c22c6.svg";
export { ForwardRef as ReactComponent };